import { Routes } from "@angular/router";
import { adminGuard, authenticationGuard } from "./shared/guards";

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'tableau-de-bord'
  },
  {
    path: 'tableau-de-bord',
    loadChildren: async () => (await import('./pages/dashboard')).routes,
    canActivate: [
      () => authenticationGuard()
    ]
  },
  {
    path: 'mon-rapport-detaille/:clientId',
    loadChildren: async () => (await import('./pages/dashboard/dsp/reporting')).routes,
    canActivate: [
      () => authenticationGuard()
    ]
  },
  {
    path: 'documents',
    loadChildren: async () => (await import('./pages/documents')).routes,
    canActivate: [
      () => authenticationGuard()
    ]
  },
  {
    path: 'actualites',
    loadChildren: async () => (await import('./pages/news-feed')).routes,
    canActivate: [
      () => authenticationGuard()
    ]
  },
  {
    path: 'mon-compte',
    loadChildren: async () => (await import('./pages/account')).routes
  },
  {
    path: 'administration',
    loadChildren: async () => (await import('./pages/admin')).routes,
    canActivate: [
      () => authenticationGuard(),
      () => adminGuard()
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    loadChildren: async () => (await import('./pages/not-found')).routes
  }
];
